import { useState, useRef, useEffect } from "react";
import { MoreVertical } from "react-feather";
import { unifiedIsoCountries } from "@core/dictionary/global";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getUserActivePlan } from "@helpers/profileHelper";
import { useLocation, useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";

const ActionsMenu = ({ rowData, reloadClassifiedSearch }) => {
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const history = useHistory();

  const toggleMenu = () => setOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderFirstOption = () => {
    if (rowData?.redirect === "") {
      return {
        label: <span className="tw-text-gray-400">Not Available</span>,
        disabled: true,
      };
    }

    if (rowData?.redirect === "plan_required") {
      const dataset = unifiedIsoCountries[rowData?.country];
      return {
        label: (
          <>
            <div className="tw-opacity-50 tw-cursor-not-allowed" data-for={`tooltip-${rowData?.id}`} data-tip={`You have currently not subscribed to ${dataset}. Connect with your account manager for subscription details.`}>
              {rowData?.classification_type?.toLowerCase() === "export" ? "View Buyers" : "View Suppliers"}
            </div>
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" id={`tooltip-${rowData?.id}`} place="left" />
          </>
        ),
        disabled: true,
      };
    }

    if (rowData?.redirect === "not_supported") {
      const dataset = unifiedIsoCountries[rowData?.country];
      return {
        label: (
          <>
            <div className="tw-opacity-50 tw-cursor-not-allowed" data-for={`tooltip-${rowData?.id}`} data-tip={`Currently we don't support ${dataset}.`}>
              {rowData?.classification_type?.toLowerCase() === "export" ? "View Buyers" : "View Suppliers"}
            </div>
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" id={`tooltip-${rowData?.id}`} place="left" />
          </>
        ),
        disabled: true,
      };
    }

    if (rowData?.redirect === "buyer_supplier_view") {
      return {
        label: rowData?.classification_type?.toLowerCase() === "export" ? "View Buyers" : "View Suppliers",
        disabled: false,
        action: () => {
          reloadClassifiedSearch(rowData);
          trademoTrackingEvents(trackingEventDictionary.classifiedProductViewBuyerSupplierAction, generateTrackingObject(dataSource, pathname, getUserActivePlan()));
          setOpen(false);
        },
      };
    }

    return {
      label: <span className="tw-text-gray-400">Not Available</span>,
      disabled: true,
    };
  };

  const firstOption = renderFirstOption();

  const menuItems = [
    firstOption,
    {
      label: "Tariffs",
      disabled: !rowData.hscode || rowData.hscode === "pending" || rowData.hscode === "failed",
      action: () => {
        setOpen(false);
        history.push(`compare-tariff?redirect=hs-classifier&type=${rowData?.classification_type?.toLowerCase()}&country=${rowData?.country}&hscode=${rowData?.hscode}`);
        trademoTrackingEvents(trackingEventDictionary.classifiedProductCompareTariffAction, generateTrackingObject(dataSource, pathname, getUserActivePlan()));
      },
    },
  ];

  return (
    <div className="tw-relative tw-inline-block" ref={menuRef}>
      <button onClick={toggleMenu} className="tw-p-2 tw-rounded-full hover:tw-bg-gray-100">
        <MoreVertical size={18} />
      </button>

      {open && (
        <div className="tw-absolute tw-right-12 tw-top-0 tw-w-48 tw-bg-white tw-rounded-lg tw-shadow-lg tw-z-[100]">
          <ul className="tw-py-1 tw-list-none">
            {menuItems.map((item, idx) => (
              <li
                key={idx}
                className={`tw-px-4 tw-py-2 tw-text-sm ${item.disabled ? "tw-text-gray-400 tw-cursor-not-allowed" : "tw-cursor-pointer hover:tw-bg-gray-100"}`}
                onClick={() => {
                  if (!item.disabled && item.action) {
                    item.action();
                  }
                }}>
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ActionsMenu;
